import React from 'react';
import LocalizedLink from '../../i18n/LocalizedLink';

interface BlogCardProps {
  icon: string;
  title: string;
  description: string;
  link: string;
  external?: boolean;
}

export const BlogCard: React.FC<BlogCardProps> = ({ 
  icon, 
  title, 
  description, 
  link,
  external = false 
}) => {
  const cardClasses = `
    block bg-white dark:bg-gray-900 border-2 border-blue-200 dark:border-gray-800 rounded-lg p-4 
    transition-all duration-200 hover:-translate-y-1 
    hover:shadow-xl hover:border-indigo-600 dark:hover:border-indigo-400
    group
  `;

  const content = (
    <>
      <div className="text-3xl mb-2">{icon}</div>
      <h3 className="font-semibold text-indigo-800 dark:text-indigo-200 mb-1 group-hover:text-indigo-600 dark:group-hover:text-indigo-100 transition-colors">
        {title}
      </h3>
      <p className="text-sm text-gray-600 dark:text-gray-300">{description}</p>
    </>
  );

  if (external) {
    return (
      <a 
        href={link} 
        className={cardClasses}
        target="_blank"
        rel="noopener noreferrer"
      >
        {content}
      </a>
    );
  }

  return (
    <LocalizedLink to={link} className={cardClasses}>
      {content}
    </LocalizedLink>
  );
};

export default BlogCard;
